// src/services/apiService.js

const API_BASE_URL = `${process.env.REACT_APP_CMS_BASE_URL}/api`;

const createApiService = (baseURL = API_BASE_URL) => {
  let currentBaseURL = baseURL;

  const buildURL = (url, params) => {
    const fullUrl = url.startsWith('http') ? url : `${currentBaseURL}${url}`;

    if (params) {
      const searchParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          searchParams.append(key, value);
        }
      });
      const paramString = searchParams.toString();
      return paramString ? `${fullUrl}?${paramString}` : fullUrl;
    }

    return fullUrl;
  };

  const request = async (url, options = {}) => {
    const {
      method = 'GET',
      headers = {},
      params = null,
      body = null,
      retries = 2,
      retryDelay = 1000, // in ms
    } = options;

    if (!url) {
      throw new Error('URL is required');
    }

    const fullUrl = buildURL(url, params);
    const requestHeaders = {
      'Content-Type': 'application/json',
      ...headers,
    };

    let requestBody;
    if (method !== 'GET' && body !== null) {
      if (body instanceof FormData) {
        delete requestHeaders['Content-Type'];
        requestBody = body;
      } else {
        requestBody = typeof body === 'string' ? body : JSON.stringify(body);
      }
    }

    let attempt = 0;
    let lastError;

    while (attempt <= retries) {
      try {
        const response = await fetch(fullUrl, {
          method,
          headers: requestHeaders,
          body: requestBody,
        });

        if (!response.ok) {
          const retryableStatus = [502, 503, 504];
          if (retryableStatus.includes(response.status) && attempt < retries) {
            attempt++;
            await new Promise((res) => setTimeout(res, retryDelay));
            continue;
          }

          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const contentType = response.headers.get('content-type');
        const data = contentType?.includes('application/json')
          ? await response.json()
          : await response.text();

        return data;
      } catch (err) {
        lastError = err;
        if (attempt < retries) {
          attempt++;
          await new Promise((res) => setTimeout(res, retryDelay));
        } else {
          console.error('API Service Error:', err);
          throw err;
        }
      }
    }

    throw lastError;
    // try {
    //   const requestHeaders = {
    //     'Content-Type': 'application/json',
    //     ...headers,
    //   };

    //   let requestBody;
    //   if (method !== 'GET' && body !== null) {
    //     if (body instanceof FormData) {
    //       delete requestHeaders['Content-Type'];
    //       requestBody = body;
    //     } else {
    //       requestBody = typeof body === 'string' ? body : JSON.stringify(body);
    //     }
    //   }

    //   const response = await fetch(fullUrl, {
    //     method,
    //     headers: requestHeaders,
    //     body: requestBody,
    //   });

    //   if (!response.ok) {
    //     throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    //   }

    //   const contentType = response.headers.get('content-type');
    //   const data = contentType?.includes('application/json')
    //     ? await response.json()
    //     : await response.text();

    //   return data;

    // } catch (err) {
    //   console.error('API Service Error:', err);
    //   throw err;
    // }
  };

  return {
    request,
    setBaseURL: (url) => {
      currentBaseURL = url.endsWith('/') ? url.slice(0, -1) : url;
    },
  };
};

const apiService = createApiService();

export default apiService;